import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';

@Component({
    selector: "icon-network"
    ,templateUrl: "./icon.network.component.html"
    ,styleUrls: ["./icon.network.component.scss"]
})
export class IconNetworkComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() dtgRssi:number = 0;
    itemColor:string = "badge-secondary";
    textTooltip:string = "Network상태";

    constructor(){

    }

    ngOnInit() {
        if(this.dtgRssi >= 1 && this.dtgRssi <= 84){
            //92D050
            this.itemColor = "badge-success";
        }else if(this.dtgRssi >= 85 && this.dtgRssi <= 102){
            //FAE100
            this.itemColor = "badge-warning";
        }else if(this.dtgRssi >= 103 && this.dtgRssi <= 111){
            //FFC000
            this.itemColor = "badge-orange";
        }else if(this.dtgRssi >= 112 && this.dtgRssi <= 254){
            //FF0000
            this.itemColor = "badge-pink";
        }else if(this.dtgRssi === 255){
            //C00000
            this.itemColor = "badge-danger";
        }else{
            //777777
            this.itemColor = "badge-secondary";
        }
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        
    }

    // @Input()
    // set val(rssi) {
    //     rssi = parseInt(rssi);
    //     this.rssi = rssi;

    //     if(this.rssi >= 1 && this.rssi <= 84){
    //         //92D050
    //         this.itemColor = "badge-success";
    //     }else if(this.rssi >= 85 && this.rssi <= 102){
    //         //FAE100
    //         this.itemColor = "badge-warning";
    //     }else if(this.rssi >= 103 && this.rssi <= 111){
    //         //FFC000
    //         this.itemColor = "badge-orange";
    //     }else if(this.rssi >= 112 && this.rssi <= 254){
    //         //FF0000
    //         this.itemColor = "badge-pink";
    //     }else if(this.rssi === 255){
    //         //C00000
    //         this.itemColor = "badge-danger";
    //     }else{
    //         //777777
    //         this.itemColor = "badge-secondary";
    //     }
    // }
}